export default function hasOwnProperty(o, prop) {
  return Object.prototype.hasOwnProperty.call(o, prop);
}
